import React, { useEffect, useState } from 'react'
import { FirebaseHelper } from '../../firebase-helper';
import loading from '../../assets/Images/loading.jpg'; 
import './Image.scss';


function Image(props) {

    const [imageUrl, setImageUrl] = useState(loading);

    const getWallpaper = async (path,id,type) => {
        setImageUrl(await FirebaseHelper.getImage(path, id, type));
        console.log("Image Fetched");
    }
    useEffect(()=>{
        getWallpaper(props.path,props.id,props.type);
    },[])

    return (
        <img className='image' src={imageUrl} onClick={props.onClick}/>
    )
}

export default Image